<template>
<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
    <v-card-text>Are you sure you want to remove the distance from the accommodation {{hsaf.huis_code}} ?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="warning mx-2" small @click="rmHsaf">Yes</v-btn>
      <v-btn color="success"  small @click="dialog = false">No</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>

export default {
  data() { 
    return {
      dialog: false,
      hsaf_encrid: null,
      hsaf: {}
    }
  },
  methods: {
    open(hsaf_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huis/hsaf/getHsaf.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHsaf"
          },
          getHsaf: {
            hsaf_encrid: hsaf_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hsaf = res.data.getHsaf;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rmHsaf() { 
      this.$axios
        .post("ares/json/ares/huis/hsaf/rmHsaf.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "rmHsaf"
          },
          rmHsaf: {
            hsaf_encrid: this.hsaf.hsaf_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {             
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.rmHsaf.text,
              color: res.data.rmHsaf.color
            });
            this.$emit('updateData');
            this.dialog = false;
          }
        })
    },
  }
}
</script>

